import type { PageSection } from "@/lib/api";

/** First enabled CTA section on a CMS page (by position). */
export function findCtaSection(sections: PageSection[]): PageSection | undefined {
  return [...sections]
    .filter((s) => s.enabled && s.kind === "cta")
    .sort((a, b) => a.position - b.position)[0];
}

export function pageHasCtaSection(sections: PageSection[]): boolean {
  return sections.some((s) => s.enabled && s.kind === "cta");
}

/** About page: match home bottom CTA (dark gradient band). */
export function withDarkCtaStyle(section: PageSection): PageSection {
  if (section.kind !== "cta") {
    return section;
  }
  const data = { ...section.data, style: "dark" as const };
  const dataAr = section.dataAr
    ? { ...section.dataAr, style: "dark" as const }
    : section.dataAr;
  return { ...section, data, dataAr };
}
